export default __webpack_public_path__ + "8cb34d99c93cdd5cce39539a30c34e22.jpg";